import styled, { DefaultTheme } from 'styled-components'
import { IonInput, IonItem, IonLabel } from '@ionic/react'
import { transparentize } from 'polished'

export const StyledIonItem = styled(IonItem)`
  --background-focused: ${({ theme }: { theme: DefaultTheme }) => theme.color.white};
  --highlight-height: 0;
  --border-radius: ${({ theme }: { theme: DefaultTheme }) => theme.global.borderRadius}px;
  --border-style: solid;
  --border-width: ${({ theme }: { theme: DefaultTheme }) => theme.global.borderWidth}px;
  --border-color: ${({ theme }: { theme: DefaultTheme }) => transparentize(0.5, theme.color.doveGray)};
  --inner-border-width: 0;

  height: 3.8em;
  overflow: visible;

  &.ion-focused {
    --border-color: ${({ theme }: { theme: DefaultTheme }) => theme.global.brandColor};
  }
`

export const StyledIonLabel = styled(IonLabel)`
  position: absolute;
  top: -1.46rem;
  padding: 0 0.2em;
  font-size: 1.15rem !important;
  background-color: ${({ theme }: { theme: DefaultTheme }) => theme.color.white};
  color: ${({ theme }: { theme: DefaultTheme }) => theme.global.color} !important;
`

export const StyledIonInput = styled(IonInput)`
  --color: ${({ theme }: { theme: DefaultTheme }) => theme.global.color};

  font-size: 1rem;

  .native-input {
    padding: 1em;
  }

  .label-text-wrapper {
    margin-right: 0;
  }

  .input-wrapper {
    height: 3.8em;
  }
`
